import "./styles/App.scss";
import Home from "./containers/Home";

const App = () => {
  return <Home />;
};

export default App;
